import React from "react";
import * as _ from "lodash";
import BcfButton from "./bcfButton";
import * as SmartDrawings from "../../smartDrawings";

export interface BcfButtonsProps {
    bcf: SmartDrawings.BcfInfo;

    gotoViewpoint: (markupIndex: number, snapshotIndex: number) => void;
    gotoHome: () => void;
}

export default class BcfButtons extends React.Component<BcfButtonsProps> {
    private static readonly indexHome = -2;
    private buttons: BcfButton[];
    private homeButton: BcfButton;

    constructor(props: BcfButtonsProps) {
        super(props);
    }

    setViewpoint(index: number) {
        for (let n = 0; n < this.buttons.length; n++)
            this.buttons[n].setActive(n === index);

        this.homeButton.setActive(false);
        this.props.gotoViewpoint(index, 0);
    }

    gotoHome() {
        for (let n = 0; n < this.buttons.length; n++)
            this.buttons[n].setActive(false);

        this.homeButton.setActive(true);
        this.props.gotoHome();
    }

    buttonAdded(button: BcfButton, index: number) {
        if (index === BcfButtons.indexHome) {
            this.homeButton = button;
            return;
        }

        this.buttons.push(button);
    }

    reset() {
        for (let n = 0; n < this.buttons.length; n++)
            this.buttons[n].setActive(false);

        this.homeButton.setActive(false);
    }

    render() {
        this.buttons = [];

        const items = this.props.bcf.Markups.map((markup, i) => {
            return <React.Fragment key={`ButtonsFragment${i}`}>
                <BcfButton ref={button => this.buttonAdded(button, i)}
                    name={markup.Topic.Title} index={i}
                    onClick={() => this.setViewpoint(i)} />

            </React.Fragment>;
        });

        return <React.Fragment>
            <BcfButton ref={button => this.buttonAdded(button, BcfButtons.indexHome)}
                name="Home"
                index={BcfButtons.indexHome}
                onClick={() => this.gotoHome()}/>
            {items}
        </React.Fragment>;
    }
}